import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterOptions } from '@app-model/filter';
import { InformativeData, InformativePageableResponse, InformativeResponse } from '@app-model/informative';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class InformativeService {
	constructor(private http: HttpClient) {}

	paginate(filter: FilterOptions): Observable<InformativePageableResponse> {
		return this.http.post(`${environment.api}/adminInformatives/all`, filter)
			.pipe(map((response: InformativePageableResponse) => response));
	}

	getInformative(id: number): Observable<InformativeData>;
	getInformative(id: string): Observable<InformativeData>;
	getInformative(id: number|string): Observable<InformativeData> {
		return this.http.get(`${environment.api}/adminInformatives/getById/${id}`)
			.pipe(map((response: InformativeData) => response), take(1));
	}

	uploadInformativeImage(informativeId: string, image: File): Observable<InformativeResponse> {
		const formData = new FormData();
		formData.append('file', image);
		return this.http.post(`${environment.api}/adminInformatives/${informativeId}/upload-image`, formData)
			.pipe(map((response: InformativeResponse) => response));
	}

	uploadInformativeContent(informativeId: string, image: File): Observable<InformativeResponse> {
		const formData = new FormData();
		formData.append('file', image);
		return this.http.post(`${environment.api}/adminInformatives/${informativeId}/upload-content`, formData)
			.pipe(map((response: InformativeResponse) => response));
	}

	removeInformativeContent(informativeId: string): Observable<InformativeResponse> {
		return this.http.delete(`${environment.api}/adminInformatives/${informativeId}/upload-content`)
			.pipe(map((response: InformativeResponse) => response));
	}

	saveInformative(informative: InformativeData): Observable<InformativeResponse> {
		return this.http.post(`${environment.api}/adminInformatives/save`, informative)
    		.pipe(map((response: InformativeResponse) => response));
	}

	removeInformative(informativeId: string): Observable<InformativeResponse> {
		return this.http.delete(`${environment.api}/adminInformatives/remove/${informativeId}`)
    		.pipe(take(1), map((response: InformativeResponse) => response));
	}
}
